import React, { useEffect, useState } from 'react';
import DropdownLocal from './DropdownLocal';
import './dropdown.scss';

const TemplateForm = ({
  templateList,
  values,
  handleChange,
  isDisabled = false,
}) => {
  const [offers, setOffers] = useState([]);
  const [inputValues, setInputValues] = useState({});
  const [fullTemplate, setFullTemplate] = useState('');

  useEffect(() => {
    if (templateList && Array.isArray(templateList)) {
      setOffers(templateList);
    }
  }, [templateList]);

  useEffect(() => {
    if (values?.templateId) {
      const selectedOffer = offers.find(
        (offer) => offer.id === parseInt(values.templateId, 10)
      );

      if (selectedOffer) {
        updateFullTemplate(
          selectedOffer.template_body,
          selectedOffer,
          inputValues
        );
      }
    }
  }, [inputValues, values.templateId, offers]);

  const handleInputChange = (offerId, index, value) => {
    setInputValues((prevInputValues) => {
      const newInputValues = {
        ...prevInputValues,
        [`${offerId}-inputField-${index}`]: value,
      };

      const selectedOffer = offers.find(
        (offer) => offer.id === parseInt(values.templateId)
      );
      if (selectedOffer) {
        updateFullTemplate(
          selectedOffer.template_body,
          selectedOffer,
          newInputValues
        );
      }

      return newInputValues;
    });
  };

  const handleDropdownChange = (offerId, key, value) => {
    setInputValues((prevInputValues) => {
      const newInputValues = {
        ...prevInputValues,
        [`${offerId}-${key}`]: value,
      };

      const selectedOffer = offers.find(
        (offer) => offer.id === parseInt(values.templateId, 10)
      );
      if (selectedOffer) {
        updateFullTemplate(
          selectedOffer.template_body,
          selectedOffer,
          newInputValues
        );
      }

      return newInputValues;
    });
  };

  const getDropdownLabel = (options, value) => {
    if (!options) return '';
    const option = options.find((opt) => opt.value === value);
    return option ? option.label : '';
  };

  const updateFullTemplate = (templateBody, selectedOffer, inputValues) => {
    if (!templateBody) return;
    let updatedTemplate = templateBody;
    const regex =
      /\{(inputField|offerType|discountType|purchaseCount|offerAmountType)\}/g;
    let match;
    let index = 1;

    while ((match = regex.exec(templateBody)) !== null) {
      const placeholder = match[1];
      let value;
      if (placeholder === 'inputField') {
        value = inputValues[`${selectedOffer.id}-inputField-${index}`] || '';
      } else {
        const dropdownValue = inputValues[`${selectedOffer.id}-${placeholder}`];
        const dropdownOptions = selectedOffer[placeholder];
        value = getDropdownLabel(dropdownOptions, dropdownValue) || '';
      }
      index = index + 2;
      updatedTemplate = updatedTemplate.replace(match[0], value);
    }

    setFullTemplate(updatedTemplate);
    handleChange({ target: { name: 'title', value: updatedTemplate } });
  };

  const selectedOffer = offers.find(
    (offer) => offer.id === parseInt(values.templateId, 10)
  );

  return (
    <div>
      {selectedOffer && (
        <div>
          <p className='wd-100'>
            {selectedOffer.template_body
              .split(
                /\{(inputField|offerType|discountType|purchaseCount|offerAmountType)\}/
              )
              .map((part, index) => {
                if (part === 'inputField') {
                  return (
                    <input
                      disabled={isDisabled}
                      key={`${selectedOffer.id}-inputField-${index}`}
                      type={selectedOffer.inputField.value}
                      value={
                        inputValues[
                          `${selectedOffer.id}-inputField-${index}`
                        ] || ''
                      }
                      onChange={(e) =>
                        handleInputChange(
                          selectedOffer.id,
                          index,
                          e.target.value
                        )
                      }
                    />
                  );
                } else if (
                  part === 'offerType' ||
                  part === 'discountType' ||
                  part === 'purchaseCount' ||
                  part === 'offerAmountType'
                ) {
                  return (
                    <DropdownLocal
                      isDisabled={isDisabled}
                      key={`${selectedOffer.id}-${part}`}
                      id={`${selectedOffer.id}-${part}`}
                      name={part}
                      options={selectedOffer[part]}
                      placeholder={`${part}`}
                      value={inputValues[`${selectedOffer.id}-${part}`] || ''}
                      handleChange={(e) =>
                        handleDropdownChange(
                          selectedOffer.id,
                          part,
                          e.target.value,
                          index
                        )
                      }
                    />
                  );
                } else {
                  return part;
                }
              })}
          </p>
        </div>
      )}
    </div>
  );
};

export default TemplateForm;
